<template>
  <HeaderComponent></HeaderComponent>
  <ConfiguracionComponent v-if="!code"></ConfiguracionComponent>
  <UserComponent :userData="userData" :token="code" v-if="code" :isLoadingData="loadingData"
    @needReactivate="reactivate()"></UserComponent>
  <div class="home">

  </div>
  <va-modal @ok="scanNewCode()" v-model="showAlert" :message="alertMessage" title="Mensaje" no-dismiss
    :mobile-fullscreen="false" :okText="alertOkText" />
</template>

<script>
// @ is an alias to /src

import HeaderComponent from '@/components/HeaderComponent.vue'
import UserComponent from '@/components/UserComponent.vue'
import ConfiguracionComponent from '@/components/ConfiguracionComponent.vue'
import { useRoute } from 'vue-router';
import { ClientJS } from 'clientjs';
import { ls } from 'vue-lsp'
import { VaModal } from 'vuestic-ui'
import { pwa } from 'platform-detect'



export default {
  name: 'HomeView',
  data: function () {
    return {
      code: null,
      userData: { photo: '', names: '', key: null, code: null },
      fingerprint: null,
      loadingData: false,
      showAlert: false,
      alertMessage: '',
      alertOkText: ''
    }
  },
  components: {
    HeaderComponent, ConfiguracionComponent, UserComponent, VaModal
  },
  mounted() {

    if (pwa) {//change for positive condition for produccion
      this.identifyUser();
    }
  },
  methods: {
    reactivate() {
      ls.set('code', null);
      ls.set('userData', null);
      this.code = null;
      this.userData = null;
    },
    identifyUser() {

      this.code = ls.get('code', null) ? ls.get('code', null) : null;
      if (this.code) {
        this.userData = ls.get('userData');
        if (!this.userData) {
          this.userData = { photo: '', names: '', key: null, code: null };
        }
        if (!this.userData.key) {
          this.getUserData();
        }
      } else {
        const route = useRoute();
        this.code = route.params.code ? route.params.code : null;
        if (this.code) {
          ls.set('code', this.code);
          ls.set('userData', { photo: '', names: '', key: null, code: null });
          if (!this.userData.key) {
            this.getUserData();
          }
        } else {
          //this.$router.replace('/scan');
        }
      }

    },
    scanNewCode() {
      this.$router.replace('/scan');
    },
    async getUserData() {

      const client = new ClientJS();
      this.loadingData = true;
       const result = await fetch('https://gamasdeveloper.com/avanterh/api/getUserDataApp', {
     // const result = await fetch('http://avante.oorale.com/api/getUserDataApp', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': this.code
        },
        body: JSON.stringify({
          fingerprint: client.getFingerprint(),
          device: client.getUserAgent()
        })
      });
      const response = await result.json();
      if (!response.success) {
        this.showAlert = true;
        this.alertMessage = "Ocurrió un error de comunicacion, verifique su conexión a internet o intentelo mas tarde.";
      } else {
        if (!response.status) {
          this.firstRun = true;
          this.code = null;
          this.userData = { photo: '', names: '', key: null, code: null };
          ls.set('userData', this.userData);
          ls.set('code', this.code);
          this.showAlert = true;
          this.alertOkText = 'Escanear';
          this.alertMessage = response.message;
        } else {
          this.userData = response.userData;
        }
      }
      this.loadingData = false;
      ls.set('userData', this.userData);

    }
  }
}
</script>
